export default __webpack_public_path__ + "static/media/giphy.c7a8acf8.webp";